module.exports = __webpack_public_path__ + "img/greybg1.bcdc56f.jpg";